/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Heading, Image, Link } from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const IeoProgramFeesSza = ({
  sectionContent,
  region,
  lang,
  prgData,
  pageData,
}) => {
  const priceData = Object.values(prgData);

  const additionalText = sectionContent?.find(
    e => e.fieldId === 'additional-off'
  );
  //console.log('-----', sectionContent, region, lang, prgData, pageData);
  // const pageConfigVal =
  //   pageData?.pageConfig?.length &&
  //   !pageData?.pageConfig[0]?.value?.disabled &&
  //   pageData?.pageConfig[0].value;
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  const router = useRouter();
  let PriceDataList = [];
  if (region === 'in') {
    config.orderedLangList[lang].forEach(language => {
      const price = priceData.filter(item => {
        return item.lang === language.toUpperCase();
      });
      if (price.length > 0) {
        PriceDataList.push(price[0]);
      }
    });
  } else {
    PriceDataList = [...priceData];
  }
  const isIndian = region === 'in';
  // const changeUi = !isIndian;
  const changeUi =
    router.asPath.indexOf('inner-engineering-pc') > 0 && isIndian;
  const [discountText, setDiscountText] = useState({});
  console.log('fddd', searchByFieldId(sectionContent, 'ieo-student-offer'));

  useEffect(() => {
    if (priceData?.length) {
      let filteredText = filter(pageConfigVal?.discounText, function (item) {
        return (
          item.code === priceData[0].coupon?.couponCode &&
          item.lang?.toLowerCase() === lang.toLowerCase()
        );
      });
      if (filteredText?.length) {
        setDiscountText(filteredText[0]);
      }
    }
  }, [priceData]);

  useEffect(() => {
    if (router.asPath.indexOf('/gift') > -1) {
      setIsGiftingFlow(true);
    }
  }, [router.asPath]);

  return (
    <Box
      bg={
        isThemeActive && pageConfigVal?.prgFees?.bgImage?.desktop
          ? `url(${pageConfigVal?.prgFees?.bgImage?.desktop})`
          : `url(https://static.sadhguru.org/d/46272/1694863180-program-fee.png)`
      }
      bgRepeat="no-repeat"
      bgSize="cover"
      id="ieo-program-fees-sza"
    >
      <Flex
        maxW={1080}
        bgRepeat="no-repeat"
        pt={{ base: '60px', md: '100px' }}
        mx="auto"
        // mt={{ base: '0px', md: '-140px' }}
      >
        <Flex
          w="full"
          mx="auto"
          flexWrap="wrap"
          px={{ base: changeUi ? '0' : '16px', xl: 0 }}
          pt={{
            base: '0px',
            md: lang === 'ar' ? '30px' : '40px',
            xl: '40px',
          }}
        >
          <Flex
            w="full"
            px={{ base: changeUi ? '16px' : '0', xl: 0 }}
            flexDir={{ base: 'column', lg: 'row' }}
            justifyContent="space-between"
            alignItems={changeUi && { base: 'flex-start', lg: 'center' }} // just remove for the older ui
            gridGap={{ base: '30px', md: '80px', '2xl': '70px' }}
            css={{
              '-webkit-grid-gap': '40px',
              '@media screen and (min-width: 768px)': {
                '-webkit-grid-gap': '80px',
              },
            }}
            pb="40px"
          >
            <Box
              color="#fff"
              w={{
                base: '100%',
                md: '60%',
                lg: '80%',
                xl: pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
                '2xl': pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
              }}
              display="flex"
              justifyContent="flex-start"
              flexDirection="column"
              alignItems={lang === 'ar' ? 'flex-end' : 'flex-start'}
            >
              <Heading
                as="h2"
                {...ProgramFeeSt[lang].h2}
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
                fontSize={{ base: '40px', lg: '55px' }}
              >
                {sectionContent?.[0]?.titleSubtext}{' '}
                {sectionContent?.[0]?.titleText}
              </Heading>
              <StructuredTextParser
                my="15px"
                str={render(sectionContent?.[2].body)}
                {...ProgramFeeSt[lang].p}
                maxW="auto"
                color="#fff"
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
              />
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[3].body)}
                {...ProgramFeeSt[lang].p1}
                maxW="auto"
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
              />

              <Image
                src={sectionContent[1]?.image?.url}
                alt=""
                left="0px"
                mt="20px"
              />
            </Box>

            {priceData[0]?.coupon?.couponCode && pageConfigVal?.prgFees ? (
              <Flex
                bg={`url(${pageConfigVal?.prgFees?.offerBg?.desktop})`}
                bgRepeat="no-repeat"
                bgSize="cover"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '20px', md: '70px' }}
                flexDir="column"
                position="relative"
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.7985 17.5208L34.7477 15.8735L31.1611 15.9836L32.7744 13.985L31.4914 12.9517L28.9888 16.0514L24.6611 16.1827L28.4044 11.5459L27.5448 10.1527L21.7266 11.4315L23.7761 7.61624L27.6676 6.76087L27.3162 5.15176L24.8051 5.70224L26.5031 2.5433L25.0507 1.76414L23.3527 4.92309L22.4295 2.52636L20.8924 3.11919L22.3237 6.83709L20.2742 10.6524L18.1315 5.09247L16.497 5.14329L14.6931 10.8218L12.4149 7.13774L13.6217 3.33938L12.0507 2.83971L11.2758 5.28726L9.38723 2.23418L7.9856 3.10225L9.8742 6.15534L7.33772 5.75729L7.08365 7.38758L11.0175 8.00582L13.2957 11.6898L7.40971 10.7667L6.63479 12.2065L10.6491 16.6061L6.32144 16.7374L3.63676 13.7944L2.41722 14.9038L4.14913 16.8009L0.5625 16.911L0.613314 18.5582L4.19995 18.4481L2.5866 20.4468L3.86966 21.48L6.37225 18.3804L10.6999 18.2491L6.95662 22.8859L7.81622 24.2791L13.6344 23.0002L11.5849 26.8155L7.69342 27.6709L8.04489 29.28L10.5517 28.7295L8.85368 31.8885L10.3061 32.6676L12.0042 29.5087L12.9273 31.9054L14.4644 31.3126L13.0331 27.5947L15.0826 23.7794L17.2253 29.3393L18.8598 29.2885L20.6637 23.61L22.9419 27.294L21.7351 31.0924L23.3061 31.5921L24.0852 29.1445L25.9738 32.1976L27.3754 31.3295L25.4868 28.2764L28.0233 28.6745L28.2774 27.0484L24.3435 26.4302L22.0654 22.7462L27.9513 23.6693L28.7262 22.2296L24.7119 17.8299L29.0396 17.6986L31.7243 20.6416L32.9438 19.5322L31.2119 17.6351L34.7985 17.525V17.5208ZM20.6976 13.3413L25.7282 12.2361L22.493 16.242L19.08 16.3436L20.6976 13.3371V13.3413ZM17.3947 7.75598L19.2452 12.5622L17.6276 15.5687L15.8322 12.668L17.3905 7.76022L17.3947 7.75598ZM9.34912 12.7315L14.4348 13.5276L16.2302 16.4283L12.8172 16.5299L9.34488 12.7273L9.34912 12.7315ZM14.6634 21.0862L9.63283 22.1914L12.868 18.1856L16.2768 18.084L14.6592 21.0905L14.6634 21.0862ZM17.9664 26.6716L16.1159 21.8654L17.7335 18.8589L19.5289 21.7595L17.9706 26.6673L17.9664 26.6716ZM26.0119 21.696L20.9263 20.8999L19.1308 17.9993L22.5439 17.8976L26.0162 21.7002L26.0119 21.696Z"
                        fill="#BD0015"
                      />
                    </svg>
                  </Flex>
                  <StructuredTextParser
                    mt="0px"
                    str={render(sectionContent?.[4].body)}
                    {...ProgramFeeSt[lang].feeDiscount1}
                    maxW="auto"
                    color="#1A1D77"
                    fontSize={{ base: '16px', md: '18px' }}
                    dir={lang == 'ar' ? 'rtl' : 'ltr'}
                  />
                </Flex>

                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}

                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                    pb={{ base: '70px', md: '80px' }}
                  >
                    <StructuredTextParser
                      str={`${priceData[0]?.curr} ${priceData[0]?.pgmFee}`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#9F8569"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                    />

                    <StructuredTextParser
                      str={`${priceData[0]?.curr} ${priceData[0]?.discountedPrice}`}
                      maxW="none"
                      textDecor="line-through"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                    />
                    <Box
                      fontSize={{ base: '26px', md: '30px' }}
                      color="#BD0015"
                      fontFamily="'FedraSansStd-A-medium'"
                      pb="16px"
                      textAlign="center"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                    >
                      {discountText?.text}{' '}
                    </Box>
                    <Box
                      fontSize={{ base: '16px', md: '18px' }}
                      fontFamily="'FedraSansStd-medium'"
                    >
                      <StructuredTextParser
                        str={render(additionalText?.body)?.replace(
                          '#num#',
                          priceData[0]?.coupon.offerValue
                        )}
                        color="#9B7800"
                        dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      />
                    </Box>
                    <Box
                      fontSize={{ base: '32px', md: '42px' }}
                      color="#1A1D77"
                      fontFamily="'FedraSansStd-A-medium'"
                    >
                      {priceData[0]?.curr}{' '}
                      {priceData[0]?.coupon?.postCouponPrice}
                    </Box>
                  </Flex>
                )}

                <Image
                  src={pageConfigVal?.prgFees?.offerBgFlower?.desktop}
                  alt=""
                  position="absolute"
                  bottom={{ base: '20px', md: '15px' }}
                  left="0px"
                />
              </Flex>
            ) : (
              <Flex
                bg="#fff !important"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '20px', md: '70px' }}
                flexDir="column"
              >
                <Flex
                  alignItems="flex-start"
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  {lang === 'ar' ? (
                    <>
                      <StructuredTextParser
                        mt="0"
                        str={render(sectionContent?.[4].body)}
                        {...ProgramFeeSt[lang].feeDiscount1}
                        maxW="auto"
                        color="#6D6358"
                      />
                      <Flex>
                        <svg
                          stroke="#be1931"
                          fill="#be1931"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="2.5em"
                          width="2.5em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                        </svg>
                      </Flex>
                    </>
                  ) : (
                    <>
                      <Flex>
                        <svg
                          stroke="#be1931"
                          fill="#be1931"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="2.5em"
                          width="2.5em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                        </svg>
                      </Flex>

                      <StructuredTextParser
                        mt="0"
                        str={render(sectionContent?.[4].body)}
                        {...ProgramFeeSt[lang].feeDiscount1}
                        maxW="auto"
                        color="#6D6358"
                      />
                    </>
                  )}
                </Flex>
                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}
                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {/* <StructuredTextParser
                      str={`${priceData[0].curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0].pgmFee
                            )
                          : priceData[0].pgmFee
                      }`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                    /> */}

                    <Box
                      color="#6D6358"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                    >
                      USD 175
                    </Box>

                    <Box color="#CD9F00" {...ProgramFeeSt[lang].feeDiscount3}>
                      Free
                    </Box>
                    {sectionContent[7]?._modelApiKey === 'simple_button' && (
                      <Box
                        display="flex"
                        placeContent="center"
                        mt="20px"
                        mb="50px"
                      >
                        <Link
                          href={refineUrlDomain(
                            sectionContent[7]?.linkUrl,
                            region,
                            lang
                          )}
                          mb="30px"
                          display="block"
                          fontWeight={'500'}
                          fontFamily={'FedraSansStd-medium'}
                          fontSize={'18px'}
                          bgColor="#E86F34"
                          minH="50px"
                          textAlign="left"
                          padding={'14px 29px'}
                          borderRadius="50px"
                          color="#faf7f0"
                          textDecoration="none"
                          width={'auto'}
                          _hover={{
                            textDecoration: 'none',
                          }}
                          // cursor={prgUrl ? 'pointer' : 'not-allowed'}
                          // _hover={{
                          //   bg: prgUrl ? '#000054' : '',
                          // }}
                          // target={prgUrl ? '_blank' : ''}
                        >
                          {sectionContent[7]?.buttonText}
                        </Link>
                      </Box>
                    )}
                  </Flex>
                )}
              </Flex>
            )}
          </Flex>
        </Flex>
        <style global>
          {`
            .thanksgiving:hover svg {
              fill: #E86F34;
              color: #E86F34;
            }
            .thanksgiving:hover {
              background: '#FAE4B8';
              color: '#FFFFFF';
            }
              `}
        </style>
      </Flex>
    </Box>
  );
};

export default IeoProgramFeesSza;
